// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhallPlayerh5-container .vhallPlayerh5-startTime.hide {\n  display: none;\n}\n\n.vhallPlayerh5-container .vhallPlayerh5-startTime.display {\n  display: block;\n  font-size: 12px;\n  color: #ffffff;\n  margin: 0 15px;\n}\n", ""]);
// Exports
module.exports = exports;
